import _objectSpread from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import w, { useMemo as C, useRef as d, useEffect as p, forwardRef as E, useImperativeHandle as O } from "react";
import { OverlayScrollbars as I } from "overlayscrollbars";
var S = function S() {
    if (typeof window > "u") {
      var n = function n() {};
      return [n, n];
    }
    var l, o;
    var t = window,
      c = typeof t.requestIdleCallback == "function",
      a = t.requestAnimationFrame,
      i = t.cancelAnimationFrame,
      r = c ? t.requestIdleCallback : a,
      u = c ? t.cancelIdleCallback : i,
      s = function s() {
        u(l), i(o);
      };
    return [function (n, e) {
      s(), l = r(c ? function () {
        s(), o = a(n);
      } : n, typeof e == "object" ? e : {
        timeout: 2233
      });
    }, s];
  },
  F = function F(l) {
    var _ref = l || {},
      o = _ref.options,
      t = _ref.events,
      c = _ref.defer,
      _C = C(S, []),
      _C2 = _slicedToArray(_C, 2),
      a = _C2[0],
      i = _C2[1],
      r = d(null),
      u = d(c),
      s = d(o),
      n = d(t);
    return p(function () {
      u.current = c;
    }, [c]), p(function () {
      var e = r.current;
      s.current = o, I.valid(e) && e.options(o || {}, !0);
    }, [o]), p(function () {
      var e = r.current;
      n.current = t, I.valid(e) && e.on(t || {}, !0);
    }, [t]), p(function () {
      return function () {
        var e;
        i(), (e = r.current) == null || e.destroy();
      };
    }, []), C(function () {
      return [function (e) {
        var v = r.current;
        if (I.valid(v)) return;
        var f = u.current,
          y = s.current || {},
          b = n.current || {},
          m = function m() {
            return r.current = I(e, y, b);
          };
        f ? a(m, f) : m();
      }, function () {
        return r.current;
      }];
    }, []);
  },
  q = function q(l, o) {
    var _l$element = l.element,
      t = _l$element === void 0 ? "div" : _l$element,
      c = l.options,
      a = l.events,
      i = l.defer,
      r = l.children,
      u = _objectWithoutProperties(l, ["element", "options", "events", "defer", "children"]),
      s = t,
      n = d(null),
      e = d(null),
      _F = F({
        options: c,
        events: a,
        defer: i
      }),
      _F2 = _slicedToArray(_F, 2),
      v = _F2[0],
      f = _F2[1];
    return p(function () {
      var y = n.current,
        b = e.current;
      if (!y) return;
      var m = y;
      return v(t === "body" ? {
        target: m,
        cancel: {
          body: null
        }
      } : {
        target: m,
        elements: {
          viewport: b,
          content: b
        }
      }), function () {
        var R;
        return (R = f()) == null ? void 0 : R.destroy();
      };
    }, [v, t]), O(o, function () {
      return {
        osInstance: f,
        getElement: function getElement() {
          return n.current;
        }
      };
    }, []),
    // @ts-ignore
    /* @__PURE__ */
    w.createElement(s, _objectSpread({
      "data-overlayscrollbars-initialize": "",
      ref: n
    }, u), t === "body" ? r : /* @__PURE__ */w.createElement("div", {
      "data-overlayscrollbars-contents": "",
      ref: e
    }, r));
  },
  g = E(q);
export { g as OverlayScrollbarsComponent, F as useOverlayScrollbars };